document.addEventListener('DOMContentLoaded', () => {
  const updateBubble = () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const bubble = document.querySelector('.cart-link__bubble-num');
        const bubbleWrapper = document.querySelector('.cart-link__bubble');
        if (bubble) bubble.textContent = cart.item_count;
        if (bubbleWrapper) {
          if (cart.item_count > 0) {
            bubbleWrapper.classList.add('cart-link__bubble--visible');
          } else {
            bubbleWrapper.classList.remove('cart-link__bubble--visible');
          }
        }
      });
  };

  const muContainer = document.getElementById('mu-items-container');
  if (muContainer) {
    new MutationObserver(() => updateBubble())
      .observe(muContainer, { childList: true, subtree: true });
  } else {
    new MutationObserver((_, obs) => {
      const container = document.getElementById('mu-items-container');
      if (container) {
        obs.disconnect();
        new MutationObserver(() => updateBubble())
          .observe(container, { childList: true, subtree: true });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
});
